import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import request from 'utils/request_ajax';
import { routes } from 'constants/config';
import { Icon } from 'ui';
import Popover from 'components/shared/popover';
import ActionButton from 'components/shared/ActionButton';

class CalculateInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      recalculatedAt: this.props.groups[this.props.groupId].recalculatedAt,
      calculating: this.props.groups[this.props.groupId].calculating,
      isActive: false,
    };
    this.formattedDate = this.formattedDate.bind(this);
    this.initRecalculate = this.initRecalculate.bind(this);
    this.pollGroupCalculating = this.pollGroupCalculating.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    const currentGroup = this.props.groups[this.props.groupId];
    if (!currentGroup.recalculationState && !currentGroup.calculating)
      this.initRecalculate(currentGroup.id);
    if (
      currentGroup.recalculationState === 'in_progress' &&
      !currentGroup.calculating
    )
      this.pollGroupCalculating(currentGroup.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const nextGroup = this.props.groups[nextProps.groupId];
    if (nextGroup.id !== this.props.groupId) {
      this.setState({
        recalculatedAt: this.props.groups[nextGroup.id].recalculatedAt,
        calculating: this.props.groups[nextGroup.id].calculating,
      });
    }

    if (!nextProps.recalculationState && !nextProps.calculating)
      this.initRecalculate(nextProps.groupId);
    if (
      nextProps.recalculationState === 'in_progress' &&
      !nextProps.calculating
    )
      this.pollGroupCalculating(nextProps.groupId);
  }

  formattedDate() {
    return moment(this.state.recalculatedAt).calendar();
  }

  initRecalculate(groupId) {
    const route = routes.SMART_GROUPS + '/' + groupId + '/recalculate';

    this.setState({
      calculating: true,
      isActive: false,
    });

    this.props.setGroupInMeta({
      id: groupId,
      calculating: true,
      recalculationState: 'in_progress',
    });

    request
      .post(route)
      .then(payload => {
        this.pollGroupCalculating(groupId);
      })
      .fail(data => {
        this.setState({
          calculating: false,
          isActive: true,
        });
        this.props.setGroupInMeta({
          id: groupId,
          calculating: false,
        });
      });
  }

  pollGroupCalculating(groupId) {
    const route = routes.SMART_GROUPS + '/' + groupId + '/recalculated_at';

    this.setState({
      calculating: true,
    });

    this.props.setGroupInMeta({
      id: groupId,
      calculating: true,
    });

    request
      .get(route)
      .then(payload => {
        if (
          !payload.recalculatedAt ||
          payload.recalculationState === 'in_progress'
        ) {
          setTimeout(() => this.pollGroupCalculating(payload.id), 2000);
        } else {
          this.props.setGroupInMeta({
            id: payload.id,
            calculating: false,
            recalculatedAt: payload.recalculatedAt,
            recalculationState: payload.recalculationState,
          });

          if (Number(this.props.groupId) === payload.id) {
            this.setState({
              recalculatedAt: payload.recalculatedAt,
              calculating: false,
            });
            this.props.refreshData();
          }
        }
      })
      .fail(data => {
        this.setState({
          calculating: false,
        });

        this.props.setGroupInMeta({
          id: groupId,
          calculating: false,
        });
      });
  }

  toggleMenu() {
    if (this.state.calculating) return;
    this.setState(state => ({ isActive: !state.isActive }));
  }

  render() {
    const iconStyle = classNames('CalculateInformation-icon', {
      'c-brand-gray-darkest': this.state.isActive,
    });

    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className="CalculateInformation" onClick={this.toggleMenu}>
        {this.state.calculating ? (
          <span className="c-d">{t('smart_groups.calculating')}</span>
        ) : (
          <div>
            <div className="CalculateInformation-buttonText">
              {t('smart_groups.calculated')} {this.formattedDate()}
              <Icon className={iconStyle} name="ellipsis-v" />
            </div>
            {this.state.isActive && (
              <Popover
                styleName="CalculateInformation-popover"
                dismissCallback={this.toggleMenu}
              >
                <div className="mb-16">
                  {t('smart_groups.recalculate_description')}
                </div>
                <ActionButton
                  iconName="refresh"
                  label={t('smart_groups.recalculate')}
                  handleClick={() => this.initRecalculate(this.props.groupId)}
                />
              </Popover>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  groups: state.data.meta.groups,
});

export default connect(mapStateToProps)(CalculateInformation);
